import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { routePath } from '@brightside-web/desktop/data-access/core-services';
import { ActionCardConfigInterface, BrightsideUiModule } from '@brightside/brightside-ui';

@Component({
    selector: 'brightside-web-credit-initial-card',
    templateUrl: './credit-initial-card.component.html',
    styleUrls: ['./credit-initial-card.component.scss'],
    imports: [BrightsideUiModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreditInitialCardComponent {
  
  creditInitialCard: ActionCardConfigInterface = {
    label: 'FINANCIAL_TOOL_CREDIT_LABEL',
    title: 'FINANCIAL_TOOL_CREDIT_TITLE',
    image: '/assets/new_credit_hero.png',
    cardStyle: 'small',
    shadow: true,
    backgroundSize: 'contain',
    backgroundImageColor: 'var(--gray-5)',
    backgroundImageOrigin: 'content-box',
    backgroundImagePaddingLeft: '.5rem',
    removeMaxWidth: true
  }

  private _router = inject(Router);

  routeToCreditSetup(): void {
    this._router.navigate([routePath('credit_setup')]);
  }
}
